// import React from 'react'
// import LiveTemplateDefault from 'src/components/template/live'
// export default (props) => (
//   <LiveTemplateDefault
//     location={props.location}
//     lang="en"
//     market="us"
//     callsign="glfc"
//     title="Watch Golf Channel Live with Fubo"
//     networkName="Golf Channel"
//   />
// )

// TEMPORARY NBC DISPUTE
import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => (
  <RedirectTemplate location={props.location} destination="/live/preview/" />
)
